// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"74091f6c","287":"c534fb73","290":"4384c29a","344":"1fd4fe85","550":"a5832c2c","608":"398655a1","841":"78f53829"}[chunkId] + ".chunk.js";
};